module.exports = __webpack_public_path__ + "static/media/VectorConfirmBlue.d9573c98.svg";